import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { AdjustmentReasonModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { AdjustmentReasonBO } from './adjustment-reason.bo';

@Repository({
    boType: AdjustmentReasonBO,
    apiController: TaggedUrl.join('sales/adjustmentReasons', [Tags.Api])
})
export class AdjustmentReasonRepositoryBase extends RepositoryBase<AdjustmentReasonBO, AdjustmentReasonModel> {
    public constructor(
        http: HttpService,
        private readonly weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): AdjustmentReasonBO {
        return new AdjustmentReasonBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: AdjustmentReasonModel) {
        return {
            id: model.id,
            version: model.version,
            sun: model.sun,
            default: model.default,
            name: model.name
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<AdjustmentReasonModel> {
        return new AdjustmentReasonModel(pickBy({
            id: item.id,
            version: item.version,
            sun: item.sun,
            default: item.default,
            name: item.name
        }, val => val !== void 0));
    }
}
